import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, filter, Subscription } from 'rxjs';
import { IPlayerDashboard } from 'src/app/interfaces/player-dashboard.interface';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { PlayerDashboardService } from 'src/app/services/player-dashboard/player-dashboard.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { Platform } from '@ionic/angular';
import { StructureHelperService } from 'src/app/services/structure/structure-helper.service';

@Component({
  selector: 'app-player-dashboard',
  templateUrl: './player-dashboard.component.html',
  styleUrls: ['./player-dashboard.component.scss'],
})

export class PlayerDashboardComponent implements OnInit, OnDestroy {
  @Input() callBackFn: () => void;
  @Input() routeSrc: string;

  private customer: CustomerModel;
  private lobbyName: string;
  public PIPE_DATE_FORMAT = 'MMMM dd yyyy \'at\' hh:mm a';
  public playerDashboard: IPlayerDashboard;
  public defaultCurrency: string;
  public isIos: boolean = false;
  public title: string;

  private balance!: BalanceModel;

  public get accountBalance(): number {
    return this.balance?.forPlayCasino() || 0;
  }
  private subscr: Array<Subscription> = [];

  constructor(
    private accountBalanceService: AccountBalanceService,
    private authenticationService: AuthenticationService,
    private config: ConfigService,
    private menuStateService: MenuStateService,
    private navigator: Navigator,
    private platform: Platform,
    private playerDashboardService: PlayerDashboardService,
    private userSession: UserSessionService,
    private structureHelperService: StructureHelperService,
  ) {
    this.defaultCurrency = this.config.getConfig().DEFAULT_CURRENCY;
  }

  ngOnInit(): void {
    //to avoid open side menu on back click for links opened from dashboard
    this.menuStateService.setMenuOpenSide('');
    this.isIos = this.platform.is("ios");

    this.subscr.push(this.accountBalanceService.getBalance().subscribe((response: BalanceModel) => {
      this.balance = response;
    }));

    this.subscr.push(combineLatest([
      this.structureHelperService.mainCasinoName,
      this.userSession.getCustomer(),
    ]).pipe(
      filter(([lobbyName, customer]) => !!lobbyName && !!customer?.customerId),
      filter(([lobbyName, customer]) => (customer.customerId !== this.customer?.customerId || this.lobbyName !== lobbyName)),
    ).subscribe(([lobbyName, customer]) => {
      this.customer = customer;
      this.lobbyName = lobbyName;
      this.getDashboardInfo();
    }));
  }

  closeModal = () => {
    this.navigator.dismiss();
  };


  ngOnDestroy(): void {
    if (this.callBackFn) {
      this.callBackFn();
    }
    this.subscr.forEach(s => s.unsubscribe());
  }

  public onUpdateUserChoice(event: CustomEvent) {
    this.playerDashboard.doNotShowAgain = event.detail.checked;
    this.authenticationService
      .updateCustomData({
        propName: 'SHOW_DASHBOARD',
        propValue: !this.playerDashboard.doNotShowAgain
      })
      .subscribe({
        next: () => {
          this.userSession.refreshCustomer();
        },
        error: () => {
          //show some error ?
          this.playerDashboard.doNotShowAgain = !this.playerDashboard.doNotShowAgain;
        }
      });
  }

  private getDashboardInfo() {
    this.playerDashboardService.getPlayerDashboard(this.lobbyName).subscribe((res) => {
      this.playerDashboard = res.payload;
      this.title = `Welcome back <b>${this.playerDashboard?.customerName}</b>`;
    })
  }

  public openPendingWDPage() {
    this.navigator.navigateTo('PendingWithdrawalsComponent', { multipleModals: false });
  }

  public onClickRewardsInfo() {
    this.navigator.navigateTo('PointsConversionPage', { multipleModals: false }, {
      displayName: "How it works",
      tab: "howItWorks"
    });
  }

  public closePage() {
    this.navigator.dismissAll();
  }
}
